import { debounce } from 'lodash';
import { FOCUSABLE_ELEMENTS_STRING, KEYCODES } from '../constants';

const IS_OPEN_CLASSNAME = 'is-open';
const MENU_ITEM_HAS_CHILDREN_CLASSNAME = 'menu-item-has-children';
const IS_MENU_OPEN_CLASSNAME = 'is-menu-open';

class MainNav {
  onTogglerMainNav = () => {
    this.toggleMainNavState();
    this.toggleTogglerView();
    this.toggleMainNavView();
    this.toggleOverlay();
  };

  onTransitionendMainNav = (e) => {
    if (e.target === e.currentTarget && e.propertyName === 'transform') {
      this.manageFocus();
    }
  };

  onDropdownLinkClick = (e) => {
    const link = e.currentTarget;
    const linkHref = link.getAttribute('href');

    if (!linkHref || linkHref === '#') {
      e.preventDefault();
      const item = link.closest(`.${MENU_ITEM_HAS_CHILDREN_CLASSNAME}`);

      item.classList.toggle(IS_OPEN_CLASSNAME);
      link.setAttribute(
        'aria-expanded',
        item.classList.contains(IS_OPEN_CLASSNAME),
      );
    }
  };

  onResizeWindow = debounce(() => {
    this.setMainNavElementsTopPosition();
  }, 200);

  onDocumentKeydown = (e) => {
    if (this.isMainVanOpen && e.key === KEYCODES.ESC) {
      this.onTogglerMainNav();
    }
  };

  constructor() {
    this.DOM = {
      body: document.body,
      siteHeader: document.getElementById('js-site-header'),
      toggler: document.getElementById('js-main-nav-toggler'),
      mainNav: document.getElementById('js-main-nav-wrapper'),
      overlay: document.getElementById('js-main-nav-overlay'),
      dropdownLinks: document.querySelectorAll(
        `.${MENU_ITEM_HAS_CHILDREN_CLASSNAME} > a`,
      ),
    };

    this.isMainVanOpen = false;

    if (!this.DOM.mainNav) {
      return;
    }

    this.init();
  }

  init() {
    this.setMainNavElementsTopPosition();
    this.addListeners();
  }

  setMainNavElementsTopPosition() {
    const siteHeaderHeight = this.DOM.siteHeader.offsetHeight;
    const adminBar = document.getElementById('wpadminbar');
    let adminBarHeight = 0;
    if (adminBar) {
      adminBarHeight = adminBar.offsetHeight;
    }
    const offset = `${siteHeaderHeight + adminBarHeight}px`;

    this.DOM.mainNav.style.top = offset;
    this.DOM.overlay.style.top = offset;
  }

  addListeners() {
    this.DOM.toggler.addEventListener('click', this.onTogglerMainNav);
    this.DOM.overlay.addEventListener('click', this.onTogglerMainNav);
    this.DOM.mainNav.addEventListener(
      'transitionend',
      this.onTransitionendMainNav,
    );
    this.DOM.dropdownLinks.forEach((link) => {
      link.addEventListener('click', this.onDropdownLinkClick);
    });
    window.addEventListener('resize', this.onResizeWindow);
    window.addEventListener('orientationchange', this.onResizeWindow);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  toggleMainNavState() {
    this.isMainVanOpen = !this.isMainVanOpen;
    this.DOM.body.classList.toggle(IS_MENU_OPEN_CLASSNAME);
  }

  toggleTogglerView() {
    this.DOM.toggler.setAttribute('aria-expanded', this.isMainVanOpen);
    this.DOM.toggler.classList.toggle(IS_OPEN_CLASSNAME);
  }

  toggleMainNavView() {
    this.DOM.mainNav.classList.toggle(IS_OPEN_CLASSNAME);
  }

  toggleOverlay() {
    this.DOM.overlay.classList.toggle(IS_OPEN_CLASSNAME);
  }

  setLastFocusOwner() {
    this.DOM.setLastFocusOwner = document.activeElement;
  }

  focusFirstFocusableElInsideMainNav() {
    const allFocusables = this.DOM.mainNav.querySelectorAll(
      FOCUSABLE_ELEMENTS_STRING,
    );

    if (allFocusables.length) {
      allFocusables[0].focus();
    }
  }

  manageFocus() {
    if (this.isMainVanOpen) {
      this.setLastFocusOwner();
      this.focusFirstFocusableElInsideMainNav();
    } else {
      this.DOM.setLastFocusOwner.focus();
    }
  }
}

export default new MainNav();
